// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","fullWidth":"Button_fullWidth__HrPFw","primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49","ghost":"Button_ghost__PwUIw"};